var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"d-flex align-center"},[_c('div',{staticClass:"mr-4"},[_c('CustomerAvatar',{attrs:{"name":_vm.customer.name,"size":_vm.size}})],1),_c('div',[_vm._v(" "+_vm._s(_vm.customer.name)+" ")])])}
var staticRenderFns = []

export { render, staticRenderFns }